import { DataService, CacheService } from "base/services";
import { useAccountStore } from "base/stores";
import { USER_TYPES } from "base/constants";
import { QueryService } from "base/query";

export const AdminService = {
  async getAccount() {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(`/accounts/2/${_id}`);
    return await apiCall();
  },
  async saveAccount(accountData) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.update(`/accounts/2/${_id}`, {
      data: accountData
    });
    return await apiCall();
  },
  async addDomain(domain) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.post(`/accounts/2/${_id}/domain`, {
      data: domain
    });
    return await apiCall();
  },
  async getFavIcon(domain) {
    let result = await fetch(`https://favicongrabber.com/api/grab/${domain}`)
      .then((response) => response.json())
      .then(({ icons }) => icons.filter(({ src }) => /apple/.test(src)))
      .catch((error) => {
        console.error("Error From FavIconGrabber", error);
      });
    return Array.isArray(result) && result.length > 0 ? result[0].src : null;
  },
  async removeDomain(domainId) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.delete(
      `/accounts/2/${_id}/domain/${domainId}`
    );
    return await apiCall();
  },
  async resend(domainId) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(
      `/accounts/2/${_id}/domain/${domainId}/resend`
    );
    return await apiCall();
  },
  async getFieldList() {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(`/user/2/${_id}/fields`);
    return await apiCall();
  },
  async saveSecurity(securityData) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.post(`/accounts/2/${_id}/auth/setting`, {
      data: securityData
    });
    return await apiCall();
  },
  async getAuditDetails(params) {
    const { _id } = useAccountStore.getState();
    let query = {
      page_number: params.currentPage
    };
    if (params.rowsPerPage) {
      query["page_size"] = params.rowsPerPage;
    }
    query["apply_preference"] = true;
    if (params.q) {
      query["q"] = params.q;
    }
    const [apiCall] = DataService.get(
      `/audit/2/${_id}/${params.flow}/activity`,
      {
        query,
        data: params.ConfigJson
      }
    );
    return await apiCall();
  },
  async getHoliday({ Start, End, WeekEnds }) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(`/accounts/2/${_id}/holiday`, {
      query: { Start, End, WeekEnds }
    });
    return await apiCall();
  },
  async updateHoliday(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.post(`/accounts/2/${_id}/holiday`, {
      data: params
    });
    return await apiCall();
  },
  async saveFlowControl(flowControlData) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.post(`/accounts/2/${_id}/flow/setting`, {
      data: flowControlData
    });
    return await apiCall();
  },
  async getAllUsersList(searchText = "") {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(
      `/user/2/${_id}?page_number=1&page_size=50`,
      {
        query: { q: searchText }
      }
    );
    return await apiCall();
  },
  getAllUsers(searchText = "") {
    const { _id } = useAccountStore.getState();
    return DataService.get(
      `/user/2/${_id}?page_number=1&page_size=50&invited_user=false`,
      {
        query: { q: searchText }
      }
    );
  },
  async getAuditDataCount(params) {
    const { _id } = useAccountStore.getState();
    let query = {};
    query["apply_preference"] = true;
    if (params.q) {
      query["q"] = params.q;
    }
    const [apiCall] = DataService.get(`/audit/2/${_id}/${params.flow}/count`, {
      query
    });
    return await apiCall();
  },
  async updateUserPreference(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.post(
      `/common/2/${_id}/preference/` +
        `${params.AppId}/${params.ViewType}/${params.ViewId}/`,
      { data: params }
    );
    return await apiCall();
  },
  async getGroupsCount(params) {
    const { _id } = useAccountStore.getState();
    if (params && params.q) {
      const [apiCall] = DataService.get(`/group/2/${_id}/count`, {
        query: { q: params.q }
      });
      return await apiCall();
    } else {
      const [apiCall] = DataService.get(`/group/2/${_id}/count`);
      return await apiCall();
    }
  },
  getGroupsList(params) {
    const { _id } = useAccountStore.getState();
    let url = `/group/2/${_id}/list?page_number=${params.currentPage}&page_size=${params.rowsPerPage}`;
    let body = {};
    if (params && params.q) {
      body.query = { q: params.q };
    }
    return DataService.post(url, body);
  },
  getAllRolesList(params) {
    const { _id } = useAccountStore.getState();
    let url = `/role/2/${_id}/list?page_number=${params.currentPage}&page_size=${params.rowsPerPage}`;

    return DataService.get(url);
  },
  getAllUserTypeList: (query) => {
    const { _id } = useAccountStore.getState();
    let url = `/user/2/${_id}/UserBase/field/UserType/values?q=${query}`;
    return DataService.get(url);
  },
  async isUniqueGroupName(groupName) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.get(`/user/2/${_id}/isunique/Group`, {
      query: { q: groupName }
    });
    return await apiCall();
  },
  async saveGroup(groupData) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.post(`/group/2/${_id}`, {
      data: groupData
    });
    return await apiCall();
  },
  async updateGroup(groupId, groupData) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.update(`/group/2/${_id}/${groupId}`, {
      data: groupData
    });
    return await apiCall();
  },
  async deleteGroup(groupId) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.delete(`/group/2/${_id}/${groupId}`);
    return await apiCall();
  },
  async getAssigneeList(filter) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.get(
      `/user/2/${_id}/assignee?page_number=1&page_size=50`,
      {
        query: { q: filter }
      }
    );
    return await apiCall();
  },
  async getGroupDetails(groupId) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.get(`/group/2/${_id}/${groupId}`);
    return await apiCall();
  },
  async getUserStatusCount() {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.get(`/user/2/${_id}/status/count`);
    return await apiCall();
  },
  async getUsersCount(params) {
    const { _id } = useAccountStore.getState();
    if (params && params.q) {
      const [apiCall] = await DataService.post(`/user/2/${_id}/count`, {
        query: { q: params.q, apply_preference: true },
        data: params.ConfigJson
      });
      return await apiCall();
    } else {
      const [apiCall] = await DataService.post(`/user/2/${_id}/count`, {
        query: { apply_preference: true },
        data: params.ConfigJson
      });
      return await apiCall();
    }
  },
  async generateSCIMToken() {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.post(
      `/accounts/2/${_id}/auth/scim/token`
    );
    return await apiCall();
  },
  async saveSCIMConfiguration(config) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.update(`/accounts/2/${_id}/auth/scim`, {
      data: config
    });
    return await apiCall();
  },
  async getMetaData() {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.get(
      `/metadata/2/${_id}/user/ExtendedUser`
    );
    return await apiCall();
  },
  async getUsersList(params) {
    const { _id } = useAccountStore.getState();
    let url = `/user/2/${_id}/list?page_number=${params.currentPage}`;
    if (params.rowsPerPage) {
      url += `&page_size=${params.rowsPerPage}`;
    }
    if (params && params.q) {
      const [apiCall] = await DataService.post(url, {
        query: { q: params.q, apply_preference: true },
        data: params.ConfigJson
      });
      return await apiCall();
    } else if (params) {
      const [apiCall] = DataService.post(url, {
        query: { apply_preference: true },
        data: params.ConfigJson
      });
      return await apiCall();
    }
  },
  async createExtendedUserModel(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.update(
      `/metadata/2/${_id}/user/ExtendedUser/draft`,
      {
        data: params
      }
    );
    return apiCall();
  },
  async securityUpdate(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.update(
      `/flow/2/${_id}/user/ExtendedUser/security`,
      {
        data: params
      }
    );
    return apiCall();
  },
  async createUser(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.post(`/user/2/${_id}`, {
      data: params
    });
    return apiCall();
  },
  getUser: (userId) => {
    const { _id } = useAccountStore.getState();
    return DataService.get(`/user/2/${_id}/${userId}`);
  },
  updateUser: (userId, data) => {
    const { _id } = useAccountStore.getState();
    return DataService.update(`/user/2/${_id}/${userId}`, {
      data
    });
  },
  async saveData(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.post(`/user/2/${_id}/batch/`, {
      data: params,
      toast: false
    });
    return apiCall();
  },
  async userActivateOrDeactivate(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.post(`/user/2/${_id}/${params.type}`, {
      data: params.ids,
      toast: false
    });
    return apiCall();
  },
  async forceRestPassword(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.post(
      `/user/2/${_id}/password/forcereset`,
      {
        data: params,
        toast: false
      }
    );
    return apiCall();
  },
  async updateTwoFactorStatus(status, data = {}) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.post(`/user/2/${_id}/otp/${status}`, {
      data,
      toast: false
    });
    return apiCall();
  },
  resendVerification(params) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/user/2/${_id}/email/batch/resend`, {
      data: params
    });
  },

  resendSingleVerification(params) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/user/2/${_id}/resend`, {
      data: params
    });
  },

  async resendEmailVerification() {
    const { _id } = useAccountStore.getState();
    //this api call use for email verification from system banner
    const [apiCall] = await DataService.post(`/user/2/${_id}/email/resend`);
    return apiCall();
  },
  async getSimpleFilterFields(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = await DataService.get(
      `/user/2/${_id}/${params.flowId}/simplefilter/fields`
    );
    return await apiCall();
  },
  async getAppContext() {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(`/signin/2/${_id}/context`);
    return await apiCall();
  },
  async unLock(userId) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.update(`/user/2/${_id}/${userId}/unlock`, {
      data: {}
    });
    return await apiCall();
  },
  getListDataSource(listId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/flow/2/${accountId}/list/${listId}/items`);
  },
  getAppLookupdata(datasetId, rowId, columnId, q = "") {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(
      `/user/2/${accountId}/${datasetId}/${rowId}/${columnId}/lookup?q=${q}&page_number=1&page_size=50`
    );
  },
  async transferOwner(params) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.update(`/accounts/2/${_id}/owner`, {
      data: params
    });
    return await apiCall();
  },
  async getAdminList(filter = "") {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(
      `/user/2/${_id}?page_number=1&page_size=50`,
      {
        query: { q: filter, _user_type: USER_TYPES.ADMIN }
      }
    );
    return await apiCall();
  },
  async getAllGroupsList(searchText) {
    const { _id } = useAccountStore.getState();
    const [apiCall] = DataService.get(
      `/group/2/${_id}/list?page_number=1&page_size=50`,
      {
        query: { q: searchText }
      }
    );
    return await apiCall();
  },
  googleDryRun(config) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/batchuser/2/${_id}/sync/google/dryrun`, {
      data: config
    });
  },
  getGoogleDomains() {
    const { _id } = useAccountStore.getState();
    return DataService.get(`/batchuser/2/${_id}/sync/google/domains`);
  },
  getGoogleGroups(config) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/batchuser/2/${_id}/sync/google/groups`, {
      data: config
    });
  },
  getGoogleFields() {
    const { _id } = useAccountStore.getState();
    return DataService.get(`/batchuser/2/${_id}/sync/google/fields`);
  },
  getGoogleSyncConfig() {
    const { _id } = useAccountStore.getState();
    return DataService.get(`/accounts/2/${_id}/sync/config`);
  },
  updateGoogleSyncConfig(config) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/accounts/2/${_id}/sync/config`, {
      data: config
    });
  },
  runGoogleSyncManual(config) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/batchuser/2/${_id}/sync/google/run`, {
      data: config
    });
  },
  deleteGoogleSync() {
    const { _id } = useAccountStore.getState();
    return DataService.delete(`/accounts/2/${_id}/sync/config`);
  },
  getAzureDomains() {
    const { _id } = useAccountStore.getState();
    return DataService.get(`/batchuser/2/${_id}/sync/azure/tenant/info`);
  },
  runAzureSyncManual(config) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/batchuser/2/${_id}/sync/azure/run`, {
      data: config
    });
  },
  getAzureSyncStatus() {
    return DataService.get(
      `/batchuser/2/${useAccountStore.getState()._id}/sync/azure/status`
    );
  },
  azureDryRun(config) {
    const { _id } = useAccountStore.getState();
    return DataService.post(`/batchuser/2/${_id}/sync/azure/dryrun`, {
      data: config
    });
  },
  getAzureGroups() {
    const { _id } = useAccountStore.getState();
    return DataService.get(`/batchuser/2/${_id}/sync/azure/groups`);
  },
  getAzureFields() {
    const { _id } = useAccountStore.getState();
    return DataService.get(`/batchuser/2/${_id}/sync/azure/fields`);
  },
  doAzureLogout() {
    return DataService.delete(
      `/accounts/2/${useAccountStore.getState()._id}/sync/azure/logout`
    );
  },
  getSyncHistoryList(params) {
    let query = {
      page_number: params.currentPage,
      page_size: params.rowsPerPage
    };
    return DataService.get(
      `/batchuser/2/${useAccountStore.getState()._id}/sync/history`,
      {
        query
      }
    );
  },
  getKissflowField() {
    return DataService.get(
      `/batchuser/2/${useAccountStore.getState()._id}/sync/field`
    );
  },
  getSyncCount() {
    return DataService.get(
      `/batchuser/2/${useAccountStore.getState()._id}/sync/history/count`
    );
  },
  getSyncHistory(value) {
    return CacheService.get({
      url: `/batchuser/2/${useAccountStore.getState()._id}/sync/history/${
        value._id
      }`
    });
  },
  getSyncStatus() {
    return DataService.get(
      `/batchuser/2/${useAccountStore.getState()._id}/sync/google/status`
    );
  },
  doSyncLogout() {
    return DataService.delete(
      `/accounts/2/${useAccountStore.getState()._id}/sync/google/logout`
    );
  },

  getAccountDetails(domain) {
    return DataService.get(`https://${domain}/id`, {
      isCORS: true
    });
  },

  ssoSandbox(data) {
    return DataService.get(
      `/signin/2/${useAccountStore.getState()._id}/sso/sandbox/${data._id}`
    );
  },
  saveBotSetting(payload) {
    return DataService.update(
      `/accounts/2/${useAccountStore.getState()._id}/bot/preference`,
      {
        data: payload
      }
    );
  }
};

export const AdminQuery = {
  checkUserExistIAllSandboxesKey: ({ userId }) => [
    "accounts",
    "sandbox",
    "user",
    "exists",
    userId
  ],

  checkUserExistInAllSandboxes: ({ userId }) => {
    const accountId = useAccountStore.getState()._id;

    return QueryService.get(
      `/accounts/2/${accountId}/sandbox/user/exists/${userId}`
    );
  }
};
